<mat-form-field class="w-100">
	<input
		autocomplete="off"
		matInput
		[placeholder]="placeholder"
		[formControl]="fieldWorker"
		[matAutocomplete]="fieldWorkerTypeAhead"
		[required]="required"
	/>
	<mat-autocomplete
		[displayWith]="displayName"
		#fieldWorkerTypeAhead="matAutocomplete"
	>
		<mat-option
			*ngFor="let fw of filteredFieldWorkers$ | async"
			[value]="fw"
		>
			{{ displayName(fw) }}
		</mat-option>
	</mat-autocomplete>
	<mat-error>Required</mat-error>
</mat-form-field>
